export default __webpack_public_path__ + "static/media/Ultima Switch.0698d314.pdf";